import React from "react";
import { Link } from "react-router-dom";
import { colors, typography, surfaces } from "../styles/index";

// PLACEHOLDER - the copy from logistics-workflow was FreightPeace's own legal text. Replace this with reviewed privacy policy before
// the app takes real customers.
export default function PrivacyPolicyPage() {
  return (
    <div style={{ minHeight: "100vh", background: colors.bgSoft, padding: "48px 24px" }}>
      <div style={{ ...surfaces.card, maxWidth: 760, margin: "0 auto" }}>
        <h1 style={{ ...typography.h2, marginBottom: 12 }}>Privacy Policy</h1>
        <p style={{ ...typography.body, color: colors.text }}>
          This policy is being written. Documents and simulations belong to the organization that made them and are visible only to its members; learners who play from a shared link don't need an account.
        </p>
        <p style={{ ...typography.small, color: colors.textMuted }}>Draft - to be replaced before launch.</p>
        <Link to="/">Back to SimulateJob</Link>
      </div>
    </div>
  );
}
